import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section3 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>አገልግሎት ዘርፍ</TableCell>
              <TableCell align="center" colSpan={10}>
                የትምህርት ደረጃ
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center" colSpan={2}>
                ከዲፕሎማ በታች
              </TableCell>
              <TableCell align="center" colSpan={2}>
                ዲፕሎማ
              </TableCell>
              <TableCell align="center" colSpan={2}>
                ዲግሪ
              </TableCell>
              <TableCell align="center" colSpan={2}>
                ማስተርስ
              </TableCell>
              <TableCell align="center" colSpan={2}>
                ዶክትሬት
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ያልተሾሙ</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.not_appointed.below_diploma.male
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        below_diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.not_appointed.below_diploma
                      .female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        below_diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.not_appointed.diploma.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.not_appointed.diploma.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.not_appointed.degree.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        degree: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.not_appointed.degree.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        degree: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.not_appointed.masters.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        masters: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.not_appointed.masters.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: {
                        masters: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.not_appointed.phd.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: { phd: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.not_appointed.phd.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      not_appointed: { phd: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ሚሲዮናውያን</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.missionaries.below_diploma.male
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        below_diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.missionaries.below_diploma
                      .female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        below_diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.missionaries.diploma.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.missionaries.diploma.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.missionaries.degree.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: { degree: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.missionaries.degree.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        degree: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.missionaries.masters.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        masters: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.missionaries.masters.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: {
                        masters: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.missionaries.phd.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: { phd: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.missionaries.phd.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      missionaries: { phd: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>መምህራን</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.teachers.below_diploma.male
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: {
                        below_diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.teachers.below_diploma.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: {
                        below_diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.diploma.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { diploma: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.diploma.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { diploma: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.degree.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { degree: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.degree.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { degree: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.masters.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { masters: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.masters.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { masters: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.phd.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { phd: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.teachers.phd.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      teachers: { phd: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ወንጌላውያን</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.evangelists.below_diploma.male
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: {
                        below_diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.evangelists.below_diploma.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: {
                        below_diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.diploma.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: { diploma: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.diploma.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: {
                        diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.degree.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: { degree: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.degree.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: {
                        degree: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.masters.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: { masters: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.masters.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: {
                        masters: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.phd.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: { phd: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.evangelists.phd.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      evangelists: { phd: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>መጋቢያን</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.below_diploma.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: {
                        below_diploma: { male: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={
                    formState.servantsEducation.pastors.below_diploma.female
                  }
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: {
                        below_diploma: { female: values.floatValue }
                      }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.diploma.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { diploma: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.diploma.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { diploma: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.degree.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { degree: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.degree.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { degree: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.masters.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { masters: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.masters.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { masters: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.phd.male}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { phd: { male: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.servantsEducation.pastors.phd.female}
                  onValueChange={values => {
                    handleChange("servantsEducation", {
                      pastors: { phd: { female: values.floatValue } }
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(4)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
